'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.responseMiddleware = undefined;
var _get = require('lodash/get');
var _get2 = _interopRequireDefault(_get);
var _constants = require('../constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var responseMiddleware = exports.responseMiddleware = function responseMiddleware(_store, next, action) {
  // Only handle rejected promises
  // {error: true} is provided by redux-promise-middleware
  if (!action.error) return next(action);
  var error = action.payload;
  var onError = (0, _get2.default)(action, 'meta.onError');
  if (typeof onError === 'function') {
    onError(error);
  }
  var responseStatus = (0, _get2.default)(error, 'response.status');
  // Always catch 401s and other auth errors and kick the user out
  if (responseStatus === 401 || error.authError === true) {
    next({
      type: _constants.actionTypes.LOGOUT
    });
    return next({
      type: _constants.actionTypes.UNAUTHORIZED
    });
  }
  return next(action);
};